<h4 class="mobile-nav-title mb-2" i18n>Jobs</h4>
<div *ngIf="job.customer" class="container-fluid mb-5">
  <div class="row form-inline mb-1">
    <div class="col-8 text-bidit-primary-header">{{job.customer?.customer_BusinessName}}</div>
    <div *ngIf="!isRequesting" class="col">
      <a href="http://maps.google.com/?q={{job.quote_Address1}},{{job.quote_City}}%20{{job.quote_State}}%20{{job.quote_Postal}}" target="_blank"
         class="mb-1 btn btn-bidit-navigate float-right" i18n>Map Job</a>
      <button *ngIf="!isRequesting && !isFieldTech && allowPrint" type="button" (click)="openPrintOptionsDialog()" class="mb-1 btn btn-bidit-navigate float-right" i18n>Print</button>
      <button *ngIf="showQuoteAnalysis" type="button" (click)="quoteAnalysis()" class="mb-1 btn btn-bidit-navigate float-right" i18n>Quote Analysis</button>
      <button *ngIf="!isRequesting && !isFieldTech" type="button" (click)="materialList()" class="mb-1 btn btn-bidit-navigate float-right" i18n>Material List</button>
    </div>

    <div>
      <label for="lostStatus" class="col-form-label" i18n>Job Status</label>
      <select class="form-control" name="lostStatus" id="lostStatus"
              [disabled]="!canEdit"
              [(ngModel)]="lostStatus"
              (change)="jobStatusChanged()">
        <option value="" i18n>Active</option>
        <option value="C" i18n>Canceled</option>
        <option value="CP" i18n>Completed</option>
      </select>
    </div>

    <app-spinner [isRunning]="isRequesting"></app-spinner>
  </div>
  <div class="mb-3">
    <div class="row text-bidit-primary">
      <div class="col-6">
        <div class="form-inline font-weight-bold">
          <label class="bold" i18n>Project:</label>
          <span>{{job.quote_Name}} #{{job.quote_ProjectNumber}}</span>
        </div>
        <div class="form-inline">
          <span i18n>Contact:</span> {{job.customer.contact_FirstName}}, {{job.customer.contact_LastName}}<br />
        </div>
        <div class="form-inline">
          <span *ngIf=job.customer.contact_Phone><span i18n>Phone:</span> {{job.customer.contact_Phone}}<br /></span>
        </div>
        <div class="form-inline">
          <span *ngIf=job.customer.contact_Mobile><span i18n>Cell:</span> {{job.customer.contact_Mobile}}<br /></span>
        </div>
      </div>
      <div class="col-6">
        <div class="col font-weight-bold" i18n>Job Address</div>
        <span class="form-inline">
          <span>{{job.quote_Address1}},{{job.quote_Address2}}</span>
        </span>
        <div class="form-inline">
          <span>{{job.quote_City}}, {{job.quote_State}} {{job.quote_Postal}}</span>
        </div>
        <div class="form-inline">
          <label class="bold" i18n>Job Status: </label>
          <span *ngIf="job.quote_IsLost" style="color:red;">{{getJobStatusName(job)}}</span><br />
          <span *ngIf="!job.quote_IsLost" class="text-success">{{getJobStatusName(job)}}</span><br />
        </div>
      </div>
    </div>
  </div>
  <mat-tab-group>
    <mat-tab label="Work Orders" i18n-label>
      <div class="content">
        <div class="row my-1">
          <div class="float-end">
            <button *ngIf="canAddWorkOrder" class="btn btn-bidit-navigate mr-2" (click)="addWorkOrder()" i18n>Add Work Order</button>
            <button *ngIf="canAddWorkOrder" class="btn btn-bidit-navigate mr-2" (click)="addCustomWorkOrderItem()" i18n>Add Custom Work Area</button>
            <button *ngIf="canEditWorkOrder && checkSendAllowSendNotifications()" class="ml-2 btn btn-bidit-navigate  " (click)="sendNotification()" i18n>Send Notification</button>
          </div>
        </div>
        <div *ngFor="let workOrder of job.workOrders">
          <div class="card border-bidit-dark bg-light mb-3 shadow">
            <div class="card-body">
              <div class="col">
                <span class="text-bidit-primary-header">{{job.customer?.customer_BusinessName}}</span>
              </div>
              <div class="col">
                <a *ngIf="canEdit" class="mobile-link" (click)="editWorkOrder(workOrder)"><span i18n>Work Order #</span> {{workOrder.workOrder_Number}} </a>
                <h5 *ngIf="!canEdit"><span>Work Order #</span> {{workOrder.workOrder_Number}} </h5>
              </div>
              <div class="col">
                <div class="form-inline">
                  <label class="text-bidit-primary" i18n>Type:</label>
                  <span class="text-bidit-primary">{{workOrder.workOrderType.workOrderType_Desc}}</span>
                </div>
              </div>
              <div class="col">
                <div class="form-inline">
                  <label class="text-bidit-primary" i18n>Start Date:</label>
                  <span class="text-bidit-primary">{{workOrder.workOrder_Start | date: 'MM/dd/yyyy h:mm a'}}</span>
                </div>
              </div>
              <div class="col">
                <div class="form-inline">
                  <label class="text-bidit-primary" i18n>End Date:</label>
                  <span class="text-bidit-primary">{{workOrder.workOrder_Stop | date: 'MM/dd/yyyy h:mm a'}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-tab>
    <mat-tab [label]="noteLabel">
      <app-project-notes-mobile [project]="job"
                                (updated)="jobNotesUpdated($event)"></app-project-notes-mobile>
    </mat-tab>
    <mat-tab [label]="documentLabel">
      <app-project-documents-mobile [project]="job"
                                    (updated)="jobNotesUpdated($event)"></app-project-documents-mobile>
    </mat-tab>
    <mat-tab *ngIf="!isFieldTech" label="Change Orders" i18n-label>
      <div *ngIf="!showChangeOrder; then showChangeOrders else showChangeOrderEdit" class="content"></div>
      <ng-template #showChangeOrders>
        <div class="row my-1 col">
          <h5 i18n>Pending</h5>
          <div class="col float-right">
            <button *ngIf="canEdit" class="btn btn-bidit-navigate float-right" (click)="newChangeOrder()" i18n>Add Change Order</button>
          </div>
        </div>
        <div *ngIf="job.pendingChangeOrderCount == 0">
          <h5 i18n>No pending change orders</h5>
        </div>
        <div *ngFor="let changeOrder of job.changeOrders">
          <div *ngIf="changeOrder.changeOrderStatusType_ID == 1" class="card border-bidit-dark bg-light mb-3 shadow">
            <div class="card-body">
              <div class="col">
                <a *ngIf="canEdit" class="mobile-link" (click)="editChangeOrder(changeOrder.changeOrder_ID)">{{changeOrder.changeOrder_Name}} </a>
                <h5 *ngIf="!canEdit">{{changeOrder.changeOrder_Name}} </h5>
                <button *ngIf="canEdit" class="btn btn-bidit-delete float-right" (click)="deleteChangeOrder(changeOrder.changeOrder_ID)"></button>
              </div>
              <div class="col">
                <div class="form-inline">
                  <label class="text-bidit-primary" i18n>Comments:</label>
                  <span class="text-bidit-primary">{{changeOrder.changeOrder_Comments}}</span>
                </div>
              </div>
              <div *ngIf="changeOrder.changeOrder_BidAmount" class="col">
                <div class="form-inline">
                  <label class="text-bidit-primary" i18n>Amount:</label>
                  <span class="text-bidit-primary">${{changeOrder.changeOrder_BidAmount | number: '1.0'}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row my-1 col">
          <h5 i18n>Approved</h5>
        </div>
        <div *ngIf="job.approvedChangeOrderCount == 0">
          <h5 i18n>No approved change orders</h5>
        </div>
        <div *ngFor="let changeOrder of job.changeOrders">
          <div *ngIf="changeOrder.changeOrderStatusType_ID == 2" class="card border-bidit-dark bg-light mb-3 shadow">
            <div class="card-body">
              <div class="col">
                <a class="mobile-link" (click)="printChangeOrder(changeOrder)">{{changeOrder.changeOrder_Name}} </a>
              </div>
              <div class="col">
                <div class="form-inline">
                  <label class="text-bidit-primary" i18n>Comments:</label>
                  <span class="text-bidit-primary">{{changeOrder.changeOrder_Comments}}</span>
                </div>
              </div>
              <div class="col">
                <div class="form-inline">
                  <label class="text-bidit-primary" i18n>Revision:</label>
                  <span class="text-bidit-primary">{{changeOrder.changeOrder_Revision}}</span>
                </div>
              </div>
              <div *ngIf="changeOrder.changeOrder_BidAmount" class="col">
                <div class="form-inline">
                  <label class="text-bidit-primary" i18n>Amount:</label>
                  <span class="text-bidit-primary">${{changeOrder.changeOrder_BidAmount | number: '1.0'}}</span>
                </div>
              </div>
              <div class="col">
                <div class="form-inline">
                  <label class="text-bidit-primary" i18n>Approved:</label>
                  <span class="text-bidit-primary">{{changeOrder.changeOrder_Approved | date: 'MM/dd/yyyy h:mm a'}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
      <ng-template #showChangeOrderEdit>
        <app-change-order-mobile [value]="changeOrderId" (toggleChangeOrderDisplay)="toggleChangeOrderDisplay($event)" (updated)="changeOrderUpdated($event)"></app-change-order-mobile>
      </ng-template>
    </mat-tab>
    <mat-tab label="Job Costing" i18n-label>
      <div *ngFor="let area of areaSummaries">
        <h3>{{area.area_Name}}</h3>

        <div *ngFor="let quoteArea of area.quoteAreas" class="card border-bidit-dark bg-light mb-3 shadow">
          <div class="card-body">
            <div class="col">
              <b>
                <span *ngIf="quoteArea.acceptedItem.area_Name">{{quoteArea.acceptedItem.area_Name}}</span>
                <span *ngIf="!quoteArea.acceptedItem.area_Name">{{quoteArea.acceptedItem.subArea.subArea_Name}}</span>
              </b>
            </div>
            <div class="col">
              <div *ngIf="quoteArea.acceptedItem.item">
                {{quoteArea.acceptedItem.item.item_Name}}
              </div>
            </div>
            <div class="col">
              <span i18n>Qty Bid:</span> {{quoteArea.acceptedItem.area_BidItemUsage}}
            </div>
            <div class="col">
              <div class="form-inline">
                <label for="area_ActualItemUsage">Qty Used</label>
                <input name="area_ActualItemUsage" class="form-control" type="text"
                       [(ngModel)]="quoteArea.acceptedItem.area_ActualItemUsage" required #area_ActualItemUsage="ngModel" />
              </div>
            </div>
            <div class="col">
              <span i18n>Sqr Ftg Bid:</span> {{quoteArea.acceptedItem.area_SqrFtg}}
            </div>
            <div class="col">
              <div class="form-inline">
                <label for="area_ActualSqrFtg">Actual Sqr Ftg</label>
                <input name="area_ActualSqrFtg" class="form-control" type="text"
                       [(ngModel)]="quoteArea.acceptedItem.area_ActualSqrFtg" required #area_ActualSqrFtg="ngModel" />
              </div>
            </div>
            <div *ngFor="let accessory of quoteArea.acceptedItem.accessories">
              <div class="col">
                <b i18n>Accessory</b>
              </div>
              <div class="col">
                <span *ngIf="accessory.item">{{accessory.item.item_Name}}</span>
                <span *ngIf="!accessory.item">{{accessory.accessory_CustomName}}</span>
              </div>
              <div class="col">
                <span i18n>Qty Bid:</span> {{accessory.accessory_Quantity}}
              </div>
              <div class="col">
                <div class="form-inline">
                  <label for="accessory_ActualUsage" i18n>Qty Used</label>
                  <input name="accessoryUsed" class="form-control" type="text"
                         [(ngModel)]="accessory.accessory_ActualUsage" required #accessoryUsed="ngModel" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col">
        <h3 i18n>Job Additional Items</h3>
        <button type="button" *ngIf="canEdit" (click)="customItem()" class="mb-1 ml-1 btn btn-bidit-navigate" i18n>Add Additional Item</button>
      </div>
      <div class="card border-bidit-dark bg-light mb-3 shadow">
        <div class="card-body">
          <div *ngFor="let jobAdditionalItem of job.jobAdditionalItems">
            <div class="col">
              {{jobAdditionalItem.item.itemType.itemType_Desc}}
            </div>
            <div class="col">
              {{jobAdditionalItem.item.item_Name}}
              <button type="button" *ngIf="canEdit" class="ml-2 btn btn-bidit-delete"
                      title="Remove custom item" i18n-title (click)="removeCustomItem(jobAdditionalItem)"></button>
            </div>
            <div class="col">
              <div class="form-inline">
                <label for="jobAdditionalItem_ActualUsage" i18n>Qty Used</label>
                <input name="jobAdditionalItem_ActualUsage" class="form-control" type="text"
                       [(ngModel)]="jobAdditionalItem.jobAdditionalItem_ActualUsage" required #jobAdditionalItem_ActualUsage="ngModel" />
              </div>
            </div>
            <div *ngIf="!jobAdditionalItem.item.itemType.itemType_IsAccessory" class="col">
              <div class="form-inline">
                <label for="jobAdditionalItem_ActualSqrFtg" i18n>Actual Sqr Ftg</label>
                <input name="jobAdditionalItem_ActualSqrFtg" class="form-control" type="text"
                       [(ngModel)]="jobAdditionalItem.jobAdditionalItem_ActualSqrFtg" required #jobAdditionalItem_ActualSqrFtg="ngModel" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col">
        <h3 i18n>Custom Areas</h3>
      </div>
      <div class="card border-bidit-dark bg-light mb-3 shadow">
        <div class="card-body">
          <div class="col mt-2" *ngFor="let jobCustomItem of job.jobCustomItems">
            <!--<b>{{jobCustomItem.customItemDescription}} - {{jobCustomItem.customItemProduct}}</b>-->
            <a *ngIf="canEdit" class="mobile-link" (click)="editCustomItem(jobCustomItem.jobCustomItem_ID)">{{jobCustomItem.customItemDescription}} - {{jobCustomItem.customItemProduct}}</a>
            <div class="col">
              <div class="form-inline">
                <label for="jobCustomItem_ItemCost" i18n>Unit Cost $</label>
                <input name="jobCustomItem_ItemCost" class="form-control" type="text"
                       [(ngModel)]="jobCustomItem.jobCustomItem_ItemCost" required jobCustomItem_ItemCost="ngModel" />
              </div>
            </div>
            <div class="col">
              <div class="form-inline">
                <label for="jobCustomItem_ActualUsage" i18n>Qty Used</label>
                <input name="jobCustomItem_ActualUsage" class="form-control" type="text"
                       [(ngModel)]="jobCustomItem.jobCustomItem_ActualUsage" required jobCustomItem_ActualUsage="ngModel" />
              </div>
            </div>
            <div class="col">
              <div class="form-inline">
                <label for="jobCustomItem_ActualSqrFtg" i18n>Actual Sqr Ftg</label>
                <input name="jobCustomItem_ActualSqrFtg" class="form-control" type="text"
                       [(ngModel)]="jobCustomItem.jobCustomItem_ActualSqrFtg" required jobCustomItem_ActualSqrFtg="ngModel" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <button type="button" (click)="updateJobCosting()" class="mb-1 ml-1 btn btn-bidit-action" i18n>Update</button>
    </mat-tab>
    <mat-tab *ngIf="job.quoteAcknowledgements" [label]="acknowledgementLabel">
      <div class="pt-3">
        <app-acknowledgement-list-mobile [project]="job"></app-acknowledgement-list-mobile>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
